export default __webpack_public_path__ + "static/principle2-baef5a53b132ac826dae7523a1a73cec63e1ec333b6dfd4714fc45b60634077b.png";